/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.inverted.segment[_ngcontent-%COMP%]{border-radius:0;background:#0c4546}p[_ngcontent-%COMP%]{white-space:pre-wrap}.ui.icon.header[_ngcontent-%COMP%]{margin-bottom:0}.ui.inverted.red.segment[_ngcontent-%COMP%]{background:#4a0d6f!important}.ui.inverted.green.segment[_ngcontent-%COMP%]{background:#193e19!important}.rank-restrictions[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
